/**
 * Load all language messages in json format for the vue views
 *
 * @returns {{}} an object with all messages for all found languages
 */
export default function loadLocaleMessages() {
    const locales = require.context(
        "./../lang/",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}
